import SvgSprite from 'components/html-elements/SvgSprite';
import React, { FC } from 'react';
import { When } from 'react-if';
import { Tab } from 'react-bootstrap';
import app from 'srcJs/App';
import { MenuItem } from 'moduleBase/types/Menu';
import { NavLink } from 'components/router/NavLink';

type PropTypes = {
  tools: MenuItem[],
};

const ToolsContent: FC<PropTypes> = ({
  tools,
}) => {
  if (!tools) {
    return null;
  }

  const renderItem = (item: MenuItem) => {
    const content = (
      <>
        <span className="text-truncate">
          {item.label}
        </span>
        <When condition={item.target}>
          <SvgSprite id="external-link" size={12} additionalClassName="color-b9b9ba ml-4p" />
        </When>
      </>
    );

    if (item.target) {
      return (
        <a href={item.url} className="d-flex align-items-center" target="_blank" rel="noreferrer">
          {content}
        </a>
      );
    }

    return (
      <NavLink to={item.url} className="d-flex align-items-center">
        {content}
      </NavLink>
    );
  };

  const items = tools.map((item) => (
    <li key={item.url}>
      {renderItem(item)}
    </li>
  ));

  return (
    <Tab.Pane eventKey="tools">
      <div className="fs-22 mb-4 pb-3">
        {app.tForReact('base_menu', 'Tools')}
      </div>
      <ul className="desktop-nav-list">
        {items}
      </ul>
    </Tab.Pane>
  );
};

export { ToolsContent };
